import React, { useState } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalTitle,
	ModalBody,
	ModalFooter
} from 'adp-react-components';

import './confirmModalAction.scss';

export const ConfirmModal = ({ confirm, closeModal, title, body, onClick, onCancel = () => {}, cancelText = 'CANCEL', confirmText = 'CONFIRM', size = 'sm'}) => (<Modal
	show={confirm}
	onHide={closeModal}
	size={size}
	backdrop={true}
	closeable="true"
	keyboard={true}
	animation={true}
	className="confirm-action-modal"
>
	<ModalHeader closeButton={ true } className="info-style">
		<ModalTitle>{title || 'Are you sure?'}</ModalTitle>
	</ModalHeader>
	<ModalBody>
		<div className="confirm-modal-container">
			{body}
		</div>
	</ModalBody>
	<ModalFooter>
		<Button onClick={() => {
			closeModal();
			onCancel();
		}} buttonStyle="secondary">{cancelText}</Button>
		<Button onClick={() => {
			onClick();
			closeModal();
		}} buttonStyle="primary">{confirmText}</Button>
	</ModalFooter>
</Modal>);

export const ConfirmSpan = ({ className, children, onClick, title, body }) => {
	const [ confirm, showConfirm ] = useState(false);
	const closeModal = () => showConfirm(false);
	const openModal = () => showConfirm(true);
	if (!confirm) {
		return (<span onClick={openModal} className={className}>{children}</span>);
	}
	const props = { confirm, closeModal, title, body, onClick };
	return (
		<span>
			{children}
			<ConfirmModal {...props} />
		</span>
	);
};

export const ConfirmButton = ({ className, style = {}, children, onClick, title, body, onCancel, disabled = false }) => {
	const [ confirm, showConfirm ] = useState(false);
	const closeModal = () => showConfirm(false);
	const openModal = () => showConfirm(true);
	if (!confirm) {
		return (<Button disabled={disabled} style={style} onClick={openModal} className={className}>{children}</Button>);
	}
	const props = { confirm, closeModal, title, body, onClick, onCancel };
	return (
		<Button style={style} className={className}>
			{children}
			<ConfirmModal {...props} />
		</Button>
	);
};
